import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import App from "./App";
import "./styles/global.css";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: { retry: 1, staleTime: 30_000 },
	},
});

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement,
);
root.render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<App />
			<Toaster
				position="bottom-right"
				toastOptions={{
					style: {
						background: "#111c13",
						color: "#dff0e2",
						border: "1px solid #06a384",
						fontFamily: "'DM Sans', sans-serif",
						fontSize: "13px",
						fontWeight: 600,
					},
				}}
			/>
		</QueryClientProvider>
	</React.StrictMode>,
);
